import api from "../api/axios";

export const getTasks = async (filter) => {
  try {
    const filterQuery = Object.entries(filter)
      .map(([key, val]) => `"${key}":"${val}"`)
      .join(",");
    const response = await api.get(
      `tasks?filter={${filterQuery}}&sortBy=updated_at&sortOrder=desc`
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
export const createTask = async (taskData) => {
  try {
    const response = await api.post(`tasks/create`, taskData);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
export const updateTask = async (taskId, taskData) => {
  try {
    const response = await api.put(`tasks/${taskId}`, taskData);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const assignTask = async (taskId, assignedTo, assignedBy) => {
  try {
    const response = await api.post(`tasks/assign`, {
      task_id: taskId,
      assigned_to: assignedTo,
      assigned_by: assignedBy,
    });
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
